export const LoadingImageUrl = 'https://a.storyblok.com/f/159374/267x150/f2782ab084/loading.svg';

/** 是否为开发环境 */
export const isDevEnv = process.env.GATSBY_STORYBLOCK_VERSION === 'draft';

export const WEB_APP_EN_SIGN_UP_URL = isDevEnv
  ? 'https://test-app-12154205867b06a3.notta.ai/signup?language=en&from=official'
  : 'https://app.notta.ai/signup?language=en&from=official';

export const WEB_APP_JP_SIGN_UP_URL = isDevEnv
  ? 'https://test-app-12154205867b06a3.notta.ai/signup?language=jp&from=official'
  : 'https://app.notta.ai/signup?language=jp&from=official';

export const WEB_APP_EN_LOGIN_IN_URL = isDevEnv
  ? 'https://test-app-12154205867b06a3.notta.ai/login?language=en&from=official'
  : 'https://app.notta.ai/login?language=en&from=official';

export const WEB_APP_JP_LOGIN_IN_URL = isDevEnv
  ? 'https://test-app-12154205867b06a3.notta.ai/login?language=jp&from=official'
  : 'https://app.notta.ai/login?language=jp&from=official';
export const WEB_APP_HOME_URL = isDevEnv
  ? 'https://test-app-12154205867b06a3.notta.ai/?from=official'
  : 'https://app.notta.ai/?from=official';

export interface IImageProp {
  src: string;
  alt: string;
}

export type ButtonType = 'default' | 'primary' | 'link';

export interface ICmsRichText {
  type: 'doc';
  content: Array<object>;
}
export interface ICMSAsset {
  id: number;
  alt: string;
  name: string;
  focus: string;
  title: string;
  filename: string;
  copyright: string;
  fieldtype: string;
  is_external_url: boolean;
}

export const isEmailLinkType = (type) => type === 'email';

export const HONOR_LOGOS: IImageProp[] = [
  {
    src: 'https://a.storyblok.com/f/159374/286x60/54bba3e737/01.svg',
    alt: '作業効率改善に最適AI文字起こしサービス',
  },
  {
    src: 'https://a.storyblok.com/f/159374/266x60/f6342a232c/02.svg',
    alt: 'データの安全性で選びたいAI文字起こしサービス',
  },
  {
    src: 'https://a.storyblok.com/f/159374/276x60/b91de5789b/03.svg',
    alt: '経営者がおすすめするAI文字起こしサービス',
  },
];

export const HONOR_LOGOS_WITH_NUMBER: IImageProp[] = [
  {
    src: 'https://a.storyblok.com/f/159374/286x60/41d0079c56/1.svg',
    alt: '作業効率改善に最適AI文字起こしサービス',
  },
  {
    src: 'https://a.storyblok.com/f/159374/267x60/19e4bd7621/2.svg',
    alt: 'データの安全性で選びたいAI文字起こしサービス',
  },
  {
    src: 'https://a.storyblok.com/f/159374/279x60/2aabaaf0d3/3.svg',
    alt: '経営者がおすすめするAI文字起こしサービス',
  },
];

export const HOST_URL = 'https://www.notta.ai';

export enum HTTP_RESPONSE_CODE {
  /** @desc 请求超时，前端自定义的字段 */
  TIMEOUT = Infinity,
  /** ----------------------- Common: -------------------------- */
  /** @desc 成功 */
  SUCCESS = 0,
  /** @desc 失败 */
  FAILED = -1,
  /** @desc 服务错误 */
  SERVER_ERROR = 40000,
}
